import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppTokenHandler } from '../../CommonService/app-token-handler';
import { DataService } from '../../CommonService/data.service';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.css']
})
export class LogoutComponent implements OnInit {

  email! :string;
  constructor(private appToken: AppTokenHandler, 
    private gservice: DataService, private route: Router, private data: DataService) { }
  IsLoadingResults:any;
  ngOnInit() {
    this.appToken.clearSessionToken();
    this.IsLoadingResults = true;
    this.data.LogoutUser('Token/logout').subscribe(data => {
    this.IsLoadingResults = false;

    });
  }
  LoginValue(){
    const input = document.getElementById('message') as HTMLInputElement | null;
    var value = input?.value.trim();
    if(!this.checkValueIsNullOrEmptyOrUndefined(value)){
       this.GetUserDetails(value);
    }
    else{
      alert("Please Enter Email")
      return;
    }
  }
  GetUserDetails(email:any) {
    this.IsLoadingResults = true;

    this.appToken.clearSessionToken();
    if (this.appToken.getSessionToken().length <= 0) {
    

      this.gservice.LoginWithEmail(email).subscribe((data: any) => {
    this.IsLoadingResults = false;

        if (data.IsAuthenticated && data.IsConsent == true) {
          this.appToken.setSessionToken(data);
          this.route.navigate(['/home']);
        } else if (data.IsConsent == false) {
          this.appToken.setSessionToken(data);
          this.route.navigate(['/privacyNotice'])
        }
        else {
          this.route.navigate(['/error/1']);
        }
      }
        , (error: Response) => {
          if (error.status <= 0) {
            this.route.navigate(['/error/2']);
          } else if (error.status === 401) {
            this.route.navigate(['/error/1']);
          } else {
            this.route.navigate(['/error/2']);
          }
        }, () => {
          // this.spinnerService.ChangeProgressStatus(false);
        });
    } else {
      this.route.navigate(['/home']);
    }
  }
  checkValueIsNullOrEmptyOrUndefined(value: any){
    if(value == null || value == undefined || value == "")
    {
      return  true;
    }
    else
    {
      return false;
    }
  }
  Login() {
    this.route.navigate(['/login']);
  }
 
}
